module.exports = __webpack_public_path__ + "static/media/pickup_active.bd14d462.svg";